__turbopack_context__.v({
  "bullet": "Privacy-module__bf9rSa__bullet",
  "bullets": "Privacy-module__bf9rSa__bullets",
  "bulletsTitle": "Privacy-module__bf9rSa__bulletsTitle",
  "link": "Privacy-module__bf9rSa__link",
  "paragraph": "Privacy-module__bf9rSa__paragraph",
  "privacyContainer": "Privacy-module__bf9rSa__privacyContainer",
  "sectionContainer": "Privacy-module__bf9rSa__sectionContainer",
  "subTitle": "Privacy-module__bf9rSa__subTitle",
  "title": "Privacy-module__bf9rSa__title",
});
